import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import icons from '../../assets/comet/comet.svg';

const DropDown = ({
  data,
  placeholder,
  correctInput,
  isValidated,
  input,
  onChange,
  isFinalAttempt
}) => {
  const isCorrectOption = isValidated && input && correctInput === input;

  const getClasses = () => {
    return classNames('comet-form__field-group', {
      'comet-form--success': isCorrectOption && isFinalAttempt,
      'comet-form--error':
        isValidated && isCorrectOption === false && isFinalAttempt
    });
  };

  const getIcon = () => {
    if (isFinalAttempt) {
      if (isCorrectOption) {
        return 'check';
      } else if (isValidated && isCorrectOption === false) {
        return 'x';
      }
    }
    return 'caret-down';
  };

  const handleChange = e =>
    onChange(data.label, e.target.value !== '' ? e.target.value : null);
  /* eslint-disable jsx-a11y/no-onchange */
  return (
    <div className={getClasses()}>
      <label htmlFor={kebabCase(data.label)} className="comet-form__label">
        {data.label}
      </label>
      <div className="comet-form__select">
        <select
          id={kebabCase(data.label)}
          className="comet-form__select-input"
          onChange={handleChange}
          disabled={isValidated}
          value={input || ''}
        >
          <option className="comet-form__select-option" value="">
            {placeholder ? placeholder : 'Select an answer'}
          </option>
          {data.options.map((option, optionIndex) => {
            return (
              <option
                className="comet-form__select-option"
                key={optionIndex}
                value={option}
              >
                {option}
              </option>
            );
          })}
        </select>
        <div className="comet-form__select-visual-wrap" />
        <span className="comet-form__select-open-indicator">
          <svg
            className="comet-form__select-open-icon"
            aria-hidden="true"
            focusable="false"
          >
            <use xlinkHref={`${icons}#${getIcon()}`} />
          </svg>
        </span>
      </div>
    </div>
  );
  /* eslint-enable jsx-a11y/no-onchange */
};

DropDown.defaultProps = {
  input: null
};

DropDown.propTypes = {
  data: PropTypes.object.isRequired,
  correctInput: PropTypes.string.isRequired,
  isValidated: PropTypes.bool.isRequired,
  input: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default DropDown;



// WEBPACK FOOTER //
// ../core/src/components/Dropdown/DropDown.js